import React, { type ComponentType, lazy, type LazyExoticComponent } from 'react';

// extend lazy component with `preload` property
interface LazyPreload<Props> extends LazyExoticComponent<ComponentType<Props>> {
    preload: () => {};
}

export function ReactLazyPreload<Props>(importStatement: () => Promise<{ default: ComponentType<Props> }>) {
    const Component: LazyPreload<Props> = Object.assign(lazy(importStatement), {
        preload: importStatement,
    });

    return Component;
}
